import { Badge } from "@/components/ui/badge";
import { CreditCard } from "lucide-react";
import type { UserCreditsResponse } from "@/services/api/eventPlans";
import { useTranslation } from "@/hooks/useTranslation";

interface CreditsDisplayProps {
  credits: UserCreditsResponse;
  className?: string;
}

/**
 * JUB-157: credits are retired; /users/credits now reports legacy purchases
 * that were paid without an event and are not applied yet.
 */
export function CreditsDisplay({ credits, className }: CreditsDisplayProps) {
  const { t } = useTranslation();
  if (credits.standard === 0 && credits.premium === 0) {
    return null;
  }

  return (
    <div className={className} data-testid="credits-display">
      <div className="flex items-center gap-2 text-sm">
        <CreditCard className="h-4 w-4 text-muted-foreground" />
        <span className="text-muted-foreground">{t("purchases.unassignedLabel")}</span>
        {credits.standard > 0 && (
          <Badge variant="secondary" className="bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
            {credits.standard} Standard
          </Badge>
        )}
        {credits.premium > 0 && (
          <Badge variant="secondary" className="bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200">
            {credits.premium} Premium
          </Badge>
        )}
      </div>
    </div>
  );
}

